import { contractApi } from "@/axios";
export function reportGenerationPage(params, data) {
    return contractApi({
        url: '/report-generation/page',
        method: 'post',
        params: params,
        data: data
    })
}
//生成结题报告
export function addReportGeneration(data) {
    return contractApi({
        url: '/report-generation',
        method: 'post',
        data: data,
        headers: {
            'Content-Type': 'multipart/form-data' // 指定内容类型为 form-data
        }
    })
}
//下载生成的结题报告模板
export function downloadReportTemplate(id, annexType) {
    return contractApi({
        url: `/report-generation/attachment/${id}/${annexType}`,
        method: 'get',
        responseType: 'blob', // 设置响应类型为 blob
    });
}